import moment from 'moment'

export const groupByFacility = data => {
  let dataset = []
  let indexes = {}

  data.forEach(item => {
    let facilityId = item.facility ? item.facility.id : -1
    const index = indexes[facilityId]
    if (index === undefined) {
      indexes[facilityId] = dataset.length

      let facility = null

      if (facilityId !== -1) {
        facility = {
          id: item.facility.id,
          entity: item.facility.entity,
          name: item.facility.name,
          address: item.facility.address,
        }
      }

      dataset.push({
        facility,
        screenings: [item]
      })
    } else {
      dataset[index].screenings.push(item)
    }
  })

  return dataset
}

export const groupByPromotor = data => {
  let dataset = []
  let indexes = {}

  data.forEach(item => {
    let userId = item.user ? item.user.id : -1
    const index = indexes[userId]
    if (index === undefined) {
      indexes[userId] = dataset.length
      dataset
        .push({
          promotor: item.user,
          screenings: [item]
        })
    } else {
      dataset[index].screenings.push(item)
    }
  })

  return dataset
}

export const groupByMonth = data => {
  let dataset = []
  let indexes = {}

  data.forEach((item) => {
    let date = moment(item.start).startOf('month')
    let monthIdentifier = date.format('YYYY-MM')
    const index = indexes[monthIdentifier]
    if (index === undefined) {
      indexes[monthIdentifier] = dataset.length
      dataset
        .push({
          identifier: monthIdentifier,
          date,
          screenings: [item]
        })
    } else {
      dataset[index].screenings.push(item)
    }
  })

  console.log(dataset)
  return dataset
}
